module.exports = __webpack_public_path__ + "static/partners-poster-5aaa258e803e23220ca4068807e79ae1.jpg";